import React, { useMemo } from 'react';
import { buildCustomPresentLetterMask } from '../../../constants/games/zoomedInCustomGame';
import './CustomOpenEndedGuessWord.css';

const CustomOpenEndedGuessWord = ({ word = '', letterStatuses = null, className = '' }) => {
  const normalizedWord = String(word || '').toUpperCase();
  const letters = normalizedWord.split('');

  const presentMask = useMemo(
    () => buildCustomPresentLetterMask({ guessWord: normalizedWord, letterStatuses }),
    [normalizedWord, letterStatuses],
  );

  const wrapperClassName = ['custom-open-ended-guess-word', className].filter(Boolean).join(' ');

  return (
    <span className={wrapperClassName}>
      {letters.map((letter, index) => (
        <span
          key={`${normalizedWord}-${index}`}
          className={`custom-open-ended-guess-word__letter ${
            presentMask[index] ? 'custom-open-ended-guess-word__letter--present' : ''
          }`.trim()}
        >
          {letter}
        </span>
      ))}
    </span>
  );
};

export default CustomOpenEndedGuessWord;
